import { FC } from 'react'

import Button from '../../components/Button'

export type BuyNowButtonProps = {
  label: string
  onPress?: () => void
  isDisabled?: boolean
  isLoading?: boolean
}

// Sits side by side with the Shop Pay button (same flex row, both flex-1), so its height
// matches Shop Pay's via CSS stretch rather than a hardcoded value we don't control. Padding
// is kept identical across breakpoints (no xl: bump) since Shop Pay's own button doesn't grow
// at desktop — growing ours there made it visibly taller than Shop Pay side by side.
export const BuyNowButton: FC<BuyNowButtonProps> = ({ label, onPress, isDisabled, isLoading }) => (
  <Button
    onPress={onPress}
    data-testid='product-buy-now'
    isDisabled={isDisabled}
    isLoading={isLoading}
    // 'primary' matches Add to Cart's exact background (bg-black/90, not solid black).
    appearance='primary'
    // Shop Pay's own button computes to border-radius: 4px, height: ~42px — matched exactly.
    className='!rounded h-full w-full !max-w-full !px-5 !py-2'
    textClassName='!text-sm font-medium leading-tight xl:!text-base'
  >
    {label}
  </Button>
)
